// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-group {
    display: flex;
    gap: 10px;
    /* Adds spacing between buttons */
}

.btn {
    background-color: transparent;
    color: white;
    text-align: center;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
    outline: orange;
    border: 1px solid orange;
    height: 40px;
}

.btn:hover {
    background-color: #0056b3;
}
html, body, #root {
  height: 100%;
}
    `, "",{"version":3,"sources":["webpack://./src/components/home/home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;AACA;EACE,YAAY;AACd","sourcesContent":[".button-group {\n    display: flex;\n    gap: 10px;\n    /* Adds spacing between buttons */\n}\n\n.btn {\n    background-color: transparent;\n    color: white;\n    text-align: center;\n    padding: 10px 20px;\n    text-decoration: none;\n    border-radius: 5px;\n    transition: background-color 0.3s ease;\n    outline: orange;\n    border: 1px solid orange;\n    height: 40px;\n}\n\n.btn:hover {\n    background-color: #0056b3;\n}\nhtml, body, #root {\n  height: 100%;\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
